import React from 'react';

const IsoBadge = ({ number, year, className = "w-32 h-32 md:w-40 md:h-40" }) => {
    const id = `iso-${number}-${year}`;
    return (
        <svg
            viewBox="0 0 200 200"
            className={`${className} drop-shadow-md hover:scale-105 transition-transform duration-300 select-none`}
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                {/* Arc for top text "CERTIFIED" */}
                <path
                    id={`${id}-top`}
                    d="M 30,100 A 70,70 0 1,1 170,100"
                    fill="none"
                />
                {/* Arc for bottom text "COMPANY" */}
                <path
                    id={`${id}-bottom`}
                    d="M 170,100 A 70,70 0 0,1 30,100"
                    fill="none"
                />
            </defs>

            {/* Outer thick ring */}
            <circle cx="100" cy="100" r="94" fill="#ffffff" stroke="#074b88" strokeWidth="7" />
            <circle cx="100" cy="100" r="85" fill="none" stroke="#074b88" strokeWidth="1.5" />

            {/* Top Text: CERTIFIED */}
            <text fill="#074b88" fontSize="17" fontWeight="900" fontFamily="sans-serif" letterSpacing="3">
                <textPath href={`#${id}-top`} startOffset="50%" textAnchor="middle">
                    CERTIFIED
                </textPath>
            </text>

            {/* Bottom Text: COMPANY */}
            <text fill="#074b88" fontSize="16" fontWeight="900" fontFamily="sans-serif" letterSpacing="3">
                <textPath href={`#${id}-bottom`} startOffset="50%" textAnchor="middle">
                    COMPANY
                </textPath>
            </text>

            {/* Inner Filled Blue Circle */}
            <circle cx="100" cy="100" r="61" fill="#074b88" stroke="#ffffff" strokeWidth="2.5" />
            <circle cx="100" cy="100" r="57" fill="none" stroke="#ffffff" strokeWidth="1" />

            {/* Center ISO Text */}
            <text
                x="100"
                y="91"
                fill="#ffffff"
                fontSize="35"
                fontWeight="900"
                fontFamily="Georgia, 'Times New Roman', serif"
                textAnchor="middle"
                letterSpacing="1"
            >
                ISO
            </text>

            {/* ISO Standard Number & Year */}
            <text
                x="100"
                y="117"
                fill="#ffffff"
                fontSize="16"
                fontWeight="800"
                fontFamily="sans-serif"
                textAnchor="middle"
                letterSpacing="0.5"
            >
                {number}:{year}
            </text>
        </svg>
    );
};

export default IsoBadge;
